<script>
export default {
	name: "ChannelsSection",
	data() {
		return {};
	},
	props: {
		testimonials: {
			type: Array,
		},
	},
};
</script>
<template>
    <section>
        <div class="container">
            <h2 class="alfa text-white mb-4">
                Celebrating Our <br />
                <strong>Client’s Success</strong>
            </h2>

            <SwiperSlider>
                <swiper-slide v-for="(item, index) in testimonials" :key="`chs-${index}`">
                    <ChannelsSectionBox :data="item" />
                </swiper-slide>
            </SwiperSlider>
        </div>
    </section>
</template>

<style lang="scss" scoped>
@import '../../sass/abstracts/_mixins.scss';
section {
    background: linear-gradient(180deg, rgba(11, 11, 15, 0.45) 0%, #0b0b0f 100%),
        url('/static/images/channels-section-bg.jpg'),
        lightgray -18.269px -264.187px / 102.368% 102.116% no-repeat;
    background-size: cover;
    border-top-left-radius: 1.8rem;
    border-top-right-radius: 1.8rem;

    @include media-breakpoint-up(md) {
        background-size: contain;
    }
}
</style>
